// eslint-disable-next-line no-shadow
export enum QuestionnaireProgressEnum {
  pending = 'pending',
  enrolled = 'enrolled',
  inProcess = 'in Process',
  completed = 'completed',
}
